import { __assign, __awaiter, __generator, __read } from "tslib";
import { DialogContentType, FrameContexts, MetaOsAppContainer, } from '@metaos/hub-sdk';
import { AppHostAdaptiveCardNovaContextEventingProvider } from '@office-start/app-host-nova-eventing';
import { dialogPromiseHandlers, getHubServices, useAppHostContext, } from '@office-start/app-host-service';
import { hostVersionsInfo } from '@office-start/app-host-types';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useIdentity } from '@office-start/identity-service';
import { launchUrl } from '@office-start/launcher-service';
import { useLocStrings } from '@office-start/loc-service';
import { useAppDefinitionById } from '@office-start/m365-apps-service';
import { useRemotableRenderer } from '@office-start/remote-module-utility';
import { TaskModuleDialogControl, } from '@office-start/task-module-dialog-control';
import { observeTaskModule, submitTaskModule, } from '@office-start/task-module-dialog-service';
import React, { createRef, useCallback, useEffect, useState, } from 'react';
import { useMOSCapabilitiesFeatureSettingsTemp } from './hooks/useMOSCapabilitiesFeatureSettingsTemp';
import { createSubPageIdForStoreDialog, formatTaskModuleTitle, logTaskModuleUserAction, } from './utilities';
var dialogSizeRef = createRef();
export var updateTaskModule = function (taskModuleSize) {
    var _a;
    logTaskModuleUserAction('Resize', 'Update_Task_Module_Dialog', 'Edit');
    (_a = dialogSizeRef.current) === null || _a === void 0 ? void 0 : _a.set({
        height: taskModuleSize.height,
        width: taskModuleSize.width,
    });
};
var onCancel = function () {
    if (dialogPromiseHandlers) {
        logTaskModuleUserAction('Click', 'Cancel_Task_Module_Dialog', 'Cancel');
        dialogPromiseHandlers.externalRejector('User cancelled/closed the task module.');
    }
    submitTaskModule();
};
export var TaskModuleDialogComponent = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var TaskModuleDialogControlRenderer = useRemotableRenderer(function () { return __awaiter(void 0, void 0, void 0, function () {
        var module;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('@office-start/task-module-dialog-control')];
                case 1:
                    module = _a.sent();
                    return [2 /*return*/, module.RemotableTaskModuleDialogControl];
            }
        });
    }); }, TaskModuleDialogControl);
    var officeComponentContext = useOfficeComponentContext().data;
    var officeIdentity = useIdentity().data;
    var locString = useLocStrings().data;
    var capabilitiesFeatureSettings = useMOSCapabilitiesFeatureSettingsTemp();
    var _h = __read(useState(), 2), hubServices = _h[0], setHubServices = _h[1];
    var _j = __read(useState(null), 2), taskModuleDialog = _j[0], setTaskModualDialog = _j[1];
    useEffect(function () {
        var subscription = observeTaskModule().subscribe(setTaskModualDialog);
        return function () {
            subscription.unsubscribe();
        };
    }, []);
    // TODO: results not needed will remove when function signature changes
    var submitTask = useCallback(function (_results) {
        submitTaskModule();
    }, []);
    var updateTask = useCallback(function (dialogSize) {
        updateTaskModule(dialogSize);
    }, []);
    var appDefinition = useAppDefinitionById((_a = taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.appId) !== null && _a !== void 0 ? _a : '').appDefinition;
    var context = useAppHostContext({
        appHostSessionId: (_b = taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.appHostSessionId) !== null && _b !== void 0 ? _b : '',
        appId: (_c = taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.appId) !== null && _c !== void 0 ? _c : '',
        entityId: (_f = (_e = (_d = appDefinition === null || appDefinition === void 0 ? void 0 : appDefinition.staticTabs) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.entityId) !== null && _f !== void 0 ? _f : '',
        frameContext: FrameContexts.task,
        isFullScreen: false,
        ringId: capabilitiesFeatureSettings.ringId,
        additionalParams: taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.additionalParams,
    });
    useEffect(function () {
        var isMounted = true;
        var fetchHubServices = function () { return __awaiter(void 0, void 0, void 0, function () {
            var createdHubServices;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!taskModuleDialog || !appDefinition) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getHubServices({
                                appId: taskModuleDialog.appId,
                                appHostSessionId: (_a = taskModuleDialog.appHostSessionId) !== null && _a !== void 0 ? _a : '',
                                frameContext: FrameContexts.task,
                                userId: (_b = officeIdentity === null || officeIdentity === void 0 ? void 0 : officeIdentity.puid) !== null && _b !== void 0 ? _b : '',
                                // startTask is not needed fo task module
                                dialogHandlers: {
                                    submitTask: submitTask,
                                    updateTask: updateTask,
                                },
                            })];
                    case 1:
                        createdHubServices = _c.sent();
                        if (isMounted && createdHubServices) {
                            setHubServices(createdHubServices);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchHubServices();
        return function () {
            isMounted = false;
        };
    }, [
        taskModuleDialog,
        taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.appId,
        taskModuleDialog === null || taskModuleDialog === void 0 ? void 0 : taskModuleDialog.appHostSessionId,
        officeIdentity === null || officeIdentity === void 0 ? void 0 : officeIdentity.puid,
        submitTask,
        updateTask,
        appDefinition,
    ]);
    if (!taskModuleDialog ||
        !locString ||
        !appDefinition ||
        !context ||
        !hubServices) {
        return null;
    }
    var taskInfo = taskModuleDialog.taskInfo, dialogType = taskModuleDialog.dialogType;
    taskInfo.title = formatTaskModuleTitle((_g = taskInfo.title) !== null && _g !== void 0 ? _g : '', appDefinition.name, dialogType);
    var hideHeader = dialogType !== 'TASKMODULE';
    context.page.subPageId = hideHeader
        ? JSON.stringify(createSubPageIdForStoreDialog(dialogType))
        : context.page.subPageId;
    var fallbackHandler = function () {
        if (!taskInfo.fallbackUrl) {
            // TODO: figure out course of action if no fallback
            return;
        }
        var action = 'OpenInBrowser';
        var linkTarget = '_blank';
        launchUrl(taskInfo.fallbackUrl, { action: action, linkTarget: linkTarget });
    };
    var content;
    {
        if (taskInfo.type == DialogContentType.Card) {
            content = (React.createElement(AppHostAdaptiveCardNovaContextEventingProvider, { card: taskInfo.card, errorFallbackHandler: fallbackHandler }));
        }
        else if (taskInfo.type == DialogContentType.Url &&
            officeComponentContext &&
            officeIdentity) {
            var mosAppContainerProps = {
                hostWindow: window,
                hubServices: hubServices,
                appDefinition: appDefinition.hubSdkAppDefinition,
                contentUrl: taskInfo.url,
                title: taskInfo.title,
                context: context,
                hostVersionsInfo: hostVersionsInfo,
            };
            content = React.createElement(MetaOsAppContainer, __assign({}, mosAppContainerProps));
        }
    }
    return (TaskModuleDialogControlRenderer && (React.createElement(TaskModuleDialogControlRenderer, { taskInfo: taskModuleDialog.taskInfo, onCancel: onCancel, appName: appDefinition.name, locStrings: locString.metaOSHubResources, icon: appDefinition.largeImageUrl, hideHeader: hideHeader, ref: dialogSizeRef }, content)));
};
//# sourceMappingURL=TaskModuleDialogComponent.js.map